//export const GOODMODEMANAGESUPERADMIN = 'GODMODEMANAGESUPERADMIN'
export const GODMODEMANAGEUSER = 'GODMODEMANAGEUSER'

